import type { FC } from 'react';
import React from 'react';
import { MDText } from 'i18n-react';

import { useFilters } from 'Stores/FilterStore/VehicleListFilter/VehicleListFilterStore';
import { useMakes } from 'Stores/MakesStore/MakesStore';
import { useGetModelsById } from 'Stores/ModelsStore/ModelsStore';

import texts from '../../VehicleListV2.texts.json';
import { MakeModelDropdown } from '../dropdowns/MakeModelDropdown';
import type { MakeModelChipConfig } from '../FilterBarV2.consts';
import { getActiveLabel } from '../FilterBarV2.helpers';

import { FilterChip } from './FilterChip';

const LocalT = new MDText(texts);

export const MakeModelFilterChip: FC<{ chipConfig: MakeModelChipConfig }> = ({ chipConfig }) => {
	const filters = useFilters();
	const makes = useMakes();
	const getModelsById = useGetModelsById();
	const label = `${LocalT.translate(chipConfig.labelKey)}`;
	const selectedModels = filters.model?.length ? getModelsById(filters.model) : [];
	const activeLabel = getActiveLabel({ filterId: chipConfig.id, filters, makes, models: selectedModels });

	return (
		<FilterChip activeLabel={activeLabel} id={chipConfig.id} isActive={!!activeLabel} label={label}>
			{({ onClose, resetKey }) => <MakeModelDropdown key={resetKey} onClose={onClose} />}
		</FilterChip>
	);
};
